import { Role } from "../../../model/role/role.model";
import { SearchCriteria } from "../../../model/common/grid";
import { DeleteRoleSummary } from "../../../model/role/deleteRoleSummary.model";
import { HttpService } from '../common/http/http.service';
import { Path } from "../../../app.config";
export class RoleService {


    private httpsSrv: HttpService;

    public static $inject: Array<string> = ["HttpService"];
    constructor(httpsService: HttpService) {
        this.httpsSrv = httpsService;
    }

    getFeatures(ceid: number) {
        var options = { url: Path.APIUrl.FeatureSetListUrl(), params: { ceid: ceid } };
        return this.httpsSrv.get(options);
    }

    getAllRoles(ceid: number) {
        var options = { url: Path.APIUrl.GetAllRolesUrl(), params: { ceid: ceid } };
        return this.httpsSrv.get(options);
    }

    getAllRolesWithSearchCriteria(ceid: number, gridArg: SearchCriteria) {
        var options = { url: Path.APIUrl.GetAllRolesWithSearchCriteriaUrl(), method: "POST", data: { ceid: ceid, param: gridArg } };
        return this.httpsSrv.execute(options);
    }

    getRoleDetails(ceid: number, roleId: number) {
        var options = { url: Path.APIUrl.GetRoleDetails(), params: { ceid: ceid, roleId: roleId } };
        return this.httpsSrv.get(options);
    }

    saveRole(roleDetails: Role) {
        var opt = { url: Path.APIUrl.SaveRoleUrl(), method: "POST", data: { roleData: roleDetails } };
        return this.httpsSrv.execute(opt);
    }


    getDeleteRoleSummary(ceid: number, roleId: number) {
        var options = { url: Path.APIUrl.GetDeleteRoleSummaryListUrl(), params: { ceid: ceid, roleId: roleId } };
        return this.httpsSrv.get(options);
    }

    deleteRole(ceid: number, roleId: number, deleteRoleSummaryList: Array<DeleteRoleSummary>) {
        var opt = { url: Path.APIUrl.DeleteRoleUrl(), method: "POST", data: { ceid: ceid, roleId: roleId, deleteRoleSummaryList: deleteRoleSummaryList } };
        return this.httpsSrv.execute(opt);
    }

}